import React , { useRef, useState  } from 'react';
import emailjs from '@emailjs/browser';
import {motion} from 'framer-motion'
import { HiLocationMarker, HiMail  } from 'react-icons/hi'
import { IoIosCall } from 'react-icons/io'

function Contact() {

  const form = useRef();
  const [send, setsend] = useState(false);
 

  // sending mail

  
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm(
      'service_jap9ayn', 
      'template_mfgogqo'
      , form.current, 
      'tQqJ59dG5X2YheSSP')
      .then((result) => {
          console.log(result.text);
          setsend(true);
      }, (error) => {
          console.log(error.text);
      });
  };
  return (
    <motion.div
     className='grid grid-cols-1 md:grid-cols-2 mt-10'
      initial={{y:100, x:100}}
      animate={{y:0, x:0}}>
            <div className=' mt-10 sm:items-center p-4 '>
              <h1 className='text-3xl text-gray-600 font-medium ml-5 text-center'> Contact Info </h1>

              <p className=' text-gray-600  mt-6  '>
                lets contact here, send me message via mail. I will answer you soon as possible.
                Now you can send me and motivate me to be continue. <br />
                Thank you 👍.
              </p>
              <div className='text-gray-500 flex mt-5 items-center text-center space-x-3'>
                <IoIosCall/>
                <p> +252 63 3926597 </p>
              </div>
              <div className='text-gray-500 flex mt-10 items-center text-center space-x-3'>
                <HiMail/>
                <p> abdik1880@gmail.com </p>
              </div>
              <div className='text-gray-500 flex mt-10 items-center text-center space-x-3'>
                <HiLocationMarker/>
                <p> Sha'ab Area, Hargeisa Somaliland</p>
              </div>


            </div>
            
            <form  className='mt-20 ml-5 p-10 '  onSubmit={sendEmail} ref={form}>

              <input type=" Name"
               name='name'
               placeholder='name'
               className='  rounded-lg  shadow shadow-gray-400 p-2 w-full placeholder:text-gray-400 text-gray-600  '  />
               
               <input type="Email"
               name='email'
               placeholder=' email'                  
               className=' rounded-lg shadow shadow-gray-400 p-2 w-full placeholder:text-gray-400  text-gray-600 mt-10 '  />

            <textarea   type="message" name='message'  placeholder='Message'  className='  rounded-lg shadow  shadow-gray-400 p-5 w-full placeholder:text-gray-300 text-gray-600 mt-10 '>
              
            </textarea>

            <button type="submit" className='w-full  bg-gray-600 text-white text-center p-2 rounded-lg mt-5' > Send Message</button>

            {send &&(
          <div
            className="p-4 mb-4 text-green-700 bg-green-100 rounded-lg  "
            role="alert"
          >
            <span className="font-medium">Thanks for your reaction </span> i wil
            contact you as soon as possible
          </div>
        )}
            </form>
    
    </motion.div>
  )
}

export default Contact
